<template>
    <div class="rounded-lg bg-white shadow-md my-6 relative">
        <!-- <img class="rounded-lg" :src="$asset('/hkcm/images/banner/MKT_HKCMNEWS_NewsBereich.jpg', 'public')" alt="HKCM News" title="HKCM News"/> -->

        <!-- <div class="grid grid-cols-1 lg:grid-cols-3 gap-3 lg:gap-12">
            <img class="rounded-t-lg lg:rounded-l-lg" :src="$asset('/hkcm/images/banner/MKT_HKCMNEWS_NewsBereich.jpg', 'public')" alt="HKCM Livestream" title="HKCM Livestream"/>
            <div class="place-self-center space-y-6 px-6 lg:px-0">
                <h3>Begrenztes Angebot</h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis debitis explicabo ut placeat non tenetur earum sequi unde autem doloribus.</p>
            </div>
            <div class="place-self-center z-10 py-6 lg:py-0">
                <button class="rounded-full bg-blue text-white py-2 px-6">Jetzt beitreten!</button>
            </div>
        </div>
        <div class="hidden lg:block">
            <div class="icon-box">
                <div class="icon-group"></div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    mounted() {
        // const group = document.querySelector('.icon-group')
        // for (let index = 0; index < 5; index++) {
        //     const containerId = `container-${index}`
        //     const container = document.createElement('div')
        //     container.className = 'iconContainer'
        //     container.id = containerId
        //     group.appendChild(container)
        //     addIcons(containerId)
        // }
        // function addIcons(containerId) {
        //     const iconContainer = document.getElementById(containerId)
        //     const Unicodes = 'HKCM-NEWS'.split('')
        //     for (let index = 0; index < 50; index++) {
        //         for (let letter = 0; letter < Unicodes.length; letter++) {
        //             const icon = document.createElement('div')
        //             icon.className = 'icon fas'
        //             icon.textContent = Unicodes[letter]
        //             iconContainer.appendChild(icon)
        //         }
        //     }
        // }
    }
};
</script>

<!-- <style>
.icon-box {
    position: absolute;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: flex-end;
}
.icon-group {
    position: relative;
    transform: rotate(-30deg);
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
.iconContainer {
    display: flex;
    gap: .5em;
    font-size: 4em;
    width: 20vw;
    animation: animate 180s linear infinite;
}
.iconContainer:nth-child(even) {
    animation: animate2 180s linear infinite;
}
@keyframes animate {
    0%, 100% { transform: translateX(-100vw); }
    50% { transform: translateX(0vw); }
}
@keyframes animate2 {
    0%, 100% { transform: translateX(0vw); }
    50% { transform: translateX(-100vw); }
}

.iconContainer div.icon {
    cursor: default;
    user-select: none;
    transition: 2s;
    color: transparent;
    opacity: 0.35;
    -webkit-text-stroke: 1px #353cee;
}
.iconContainer div.icon:hover {
    color: #353cee;
    transition: 0s;
    -webkit-text-stroke: 1px transparent;
    opacity: 0.75;
    text-shadow: 0 0 70px #353cee;
}
</style> -->
